export default __webpack_public_path__ + "static/media/digit7_logo2020_new (1).6c203d51.svg";